<script type="ts">
  import type { Dropdown, TemplateTwoItems } from "../lib/interfaces";
  import { fade } from "svelte/transition";

  export let dropdown: Dropdown;

  const items : Array<TemplateTwoItems> = dropdown.template_2.items;
  const heading : string = dropdown.template_2.text;
  const fadeParams = {
    duration: 250
  };

  let activeSubitems : any;

  function activateSubitems(items: any) {
    activeSubitems = items;
  }

</script>

<div transition:fade={fadeParams} class="dropdown-two">
  <div class="dropdown-two__wrapper">

    <div class="dropdown-two__step-1" class:closed={activeSubitems}>

      {#if heading}
      <span class="dropdown-two__heading">
        {heading}
      </span>
      {/if}

      {#each items as item}

        <a transition:fade={fadeParams} href="#" on:click="{() => activateSubitems(item.subitems)}" class="dropdown-two__first-toggle">
          <img class="dropdown-two__image" src={item.icon} alt="{item.title}" />
          <span class="dropdown-two__first-toggle-title">{item.title}</span>
        </a>

      {/each}
    </div>

    <div class="dropdown-two__step-2" class:active={activeSubitems} class:closed={!activeSubitems}>
      {#if activeSubitems}
        {#each activeSubitems as subitem}


      <div transition:fade={fadeParams} class="dropdown-two__parent">
        <a href={subitem.link.url} class="dropdown-two__parent-link" class:dropdown-two__parent-link--small={subitem.links}>
          <img class="dropdown-two__image" src={subitem.icon} alt="{subitem.title}" />
          <span class="dropdown-two__first-toggle-title">{subitem.title}</span>
        </a>
        {#if subitem.links}
          <div transition:fade={fadeParams} class="dropdown-two__children">
            {#each subitem.links as child}
              <a href={child.link.url} class="dropdown-two__child-link">
                {child.link.title}
              </a>
            {/each}
          </div>
        {/if}
      </div>

        {/each}
      {/if}
    </div>

  </div>
</div>

